export function clickOutside(node: any, ignore?: string) {
	const handleClick = (event: any) => {
		const target = event.target as HTMLElement;
		if (!target || (ignore && target.closest(ignore))) {
			return;
		}
		if (!node.contains(target)) {
			node.dispatchEvent(new CustomEvent('outclick'));
		}
	};

	document.addEventListener('click', handleClick, true);

	return {
		destroy() {
			document.removeEventListener('click', handleClick, true);
		}
	};
}
